import axios from 'axios';

export type DeleteCustomerBlueprintParams = {
	// data
	email: string,
	submissionId: string,
	// token
	getToken: () => Promise<string>,
	// callbacks
	setState?: (data: any) => void,
	setError?: (error: string) => void
};

export const deleteCustomerBlueprintRequest = async (params: DeleteCustomerBlueprintParams): Promise<[any, string | null]> => {
	// eslint-disable-next-line no-empty-function, @typescript-eslint/no-empty-function
	const { email, submissionId, getToken, setState, setError } = params;

	try {
		const token = await getToken();
		const response = await axios.delete(`${import.meta.env.VITE_API_URL}/customers/${email}/blueprints/${submissionId}`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});

		if (response.status !== 204) {
			if (setError) setError(response.data);
			return [null, response.data];
		}

		localStorage.removeItem(`autosave-${submissionId}`);


		if (setState) setState([response.data]);
		return [[response.data], null];
	} catch (error) {
		if (setError) setError(error as string);
		return [null, error as string];
	}

	return [null, null];
};
